// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3h7is","comment":"styles_comment__UHq22"};